"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.btnTypes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _client = require("@apollo/client");
var _AddAllView = _interopRequireDefault(require("./AddAllFiles/AddAllView"));
var _AddSelectedFilesController = _interopRequireDefault(require("./AddSelectedFiles/AddSelectedFilesController"));
var _Snackbar = _interopRequireDefault(require("./Snackbar/Snackbar"));
var _AddToCartDialogAlertView = _interopRequireDefault(require("./AddToCartDialog/AddToCartDialogAlertView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var btnTypes = {
  ADD_ALL_FILES: 'ADD_ALL_FILES',
  ADD_SELECTED_FILES: 'ADD_SELECTED_FILES',
  DOWNLOAD_MANIFEST: 'DOWNLOAD_MANIFEST'
};
/**
* customize button based on configuration
* refer config table (wrapper component config)
*/
exports.btnTypes = btnTypes;
var AddFilesView = function AddFilesView(props) {
  var btnType = props.btnType,
    count = props.count,
    alertMessage = props.alertMessage;
  /**
  * snackbar state
  */
  var _ref = (0, _react.useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    openSnackbar = _ref2[0],
    setOpenSnackbar = _ref2[1];
  /**
  * conditionally display max file Alter/Error dialog view
  */
  var _ref3 = (0, _react.useState)(false),
    _ref4 = _slicedToArray(_ref3, 2),
    displayAlter = _ref4[0],
    setAlterDisplay = _ref4[1];
  /**
  * acess bento app client via ApolloProvider
  */
  var client = (0, _client.useApolloClient)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, btnTypes.ADD_SELECTED_FILES === btnType && /*#__PURE__*/_react.default.createElement(_AddSelectedFilesController.default, _extends({}, props, {
    client: client,
    setAlterDisplay: setAlterDisplay,
    setOpenSnackbar: setOpenSnackbar
  })), btnTypes.ADD_ALL_FILES === btnType && /*#__PURE__*/_react.default.createElement(_AddAllView.default, _extends({}, props, {
    client: client,
    setAlterDisplay: setAlterDisplay,
    setOpenSnackbar: setOpenSnackbar
  })), /*#__PURE__*/_react.default.createElement(_Snackbar.default, {
    open: openSnackbar,
    count: count,
    onClose: function onClose() {
      return setOpenSnackbar(false);
    }
  }), displayAlter && /*#__PURE__*/_react.default.createElement(_AddToCartDialogAlertView.default, {
    alertMessage: alertMessage,
    open: displayAlter,
    onClose: function onClose() {
      return setAlterDisplay(false);
    }
  }));
};
var _default = AddFilesView;
exports.default = _default;